export default {
  pagingUserTickets: '/gateway/cs/ticket/pagingUserTickets'
}
